import { sharedService } from "@/modules/shared/store/services/shared-service";

const getLoanWithdrawReasons = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLoanWithdrawReasons: builder.query({
      query: () => "parameters/loan-reasons-for-closing",
      transformResponse: response => response.items,
      providesTags: ["LoanWithdrawReasons"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanWithdrawReasonsQuery } = getLoanWithdrawReasons;

